import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { getReports as fetchReports, storeReport, updateReport, archiveReport, copyReport } from "@/services/ReportService"
import { useNavigationStore } from "@/stores/navigation";
// import { getError } from "@/utils/helpers";

export const useReportStore = defineStore('reports', () => {

    const navigationStore = useNavigationStore();

    const reports = ref([]);
    const activeReport = ref(null);

    const getReports = computed(() => reports.value)
    const getActiveReport = computed(() => activeReport.value)

    function setActiveReport(report){
        activeReport.value = report
    }

    async function setReports(){
        reports.value = await fetchReports();
    }

    async function addReport(payload){
        let report = await storeReport(payload)

        reports.value.push(report)

        let node = createNode(report)
        navigationStore.addNode(node, 'reports')
    }

    async function editReport(payload){
        updateReport(getActiveReport.value.id, payload)
    }

    async function removeReport(){
        let reportId = getActiveReport.value.id
        let reportIndex = getReports.value.findIndex((report) => report.id === reportId)

        await archiveReport(reportId)

        reports.value.splice(reportIndex, 1)

        navigationStore.removeNode(reportId);

        activeReport.value = null
    }

    // Renamed to simpler api language
    async function copy(){
        let reportId = getActiveReport.value.id
        
        let copiedReport = await copyReport(reportId)

        reports.value.push(copiedReport)

        let node = createNode(copiedReport)
        navigationStore.addNode(node, 'reports')
    }

    function createNode(report){
        let subPages = [];

        report.pages.forEach(page => {
            subPages.push({
                id: page.id,
                title: page.title, 
                route: 'report-page',
                params: { report_id: report.id, page_slug: page.slug, page_id: page.id }
            })
        })

        let node = {
            id: report.id,
            title: report.title,
            icon: 'si si-docs',
            subActivePaths: '/reports',
            items: subPages
        }

        return node
    }

    async function createReportNavigationNodes(){
        reports.value.forEach(report => {
            let node = createNode(report)
            navigationStore.addNode(node, 'reports')
        })
    }

    function $reset() {
        reports.value = []
        activeReport.value = null
    }

    return {
        getActiveReport,
        setActiveReport,
        getReports,
        setReports,
        addReport,
        editReport,
        removeReport,
        copy,
        createReportNavigationNodes,
        $reset
    }
});